<template>
  <v-container fluid>
    <div class="d-flex flex-column justify-center align-center wordbreak">
      <div class="col-12 col-lg-6">
        <v-card tile flat>
          <v-card-title class="d-flex justify-center align-center text-center wordbreak">
            {{ $t('cards.titles.welcome') }}
          </v-card-title>
          <v-card-text class="text-center">
            <div v-html="$t('cards.texts.welcome')"></div>
          </v-card-text>
        </v-card>
      </div>
    </div>

  </v-container>
</template>

<script>
import i18n from "@/services/i18n";

export default {
  i18n: i18n,
  name: "m2h-coming-soon",
  props: [],
  components: {
  },
  data() {
    return {}
  }
}
</script>

<style scoped>
.wordbreak {
  word-break: break-word !important;
}
</style>
